
import { PricingResolved } from '@/types/pricing-plan';
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { DeviceInfo } from '@/types/device-info';
import { getSubscriptionDuration, getPlanType } from '@/utils/subscriptions';
import ModelMixin from '@/mixins/ModelMixin';
import { getCurrencySymbol } from '@/utils/currency';

@Component({
    components: {},
})
export default class PlanDetailView extends Mixins<ModelMixin<number[]>>(ModelMixin) {
    @Prop({ required: true })
    plan!: PricingResolved;

    @Prop({ required: true })
    device!: DeviceInfo;

    protected getCurrencySymbol = getCurrencySymbol;

    get duration() {
        if (this.plan.duration === 'days') return `${this.plan.frequencyDays} days`;
        return getSubscriptionDuration(this.plan.duration as string);
    }

    get trialDays() {
        return this.plan.freeTrialDays ? this.plan.freeTrialDays : 'None';
    }

    get planType() {
        return getPlanType(this.plan.type);
    }

    get planTax() {
        const currency = getCurrencySymbol(this.plan?.currency ? this.plan?.currency : 'USD');
        let taxAmount = 0;
        if (this.plan?.taxRate) {
            taxAmount = (this.plan?.price / 100) * this.plan?.taxRate.percentage;
            return `${currency}${taxAmount.toFixed(2)}`;
        }
        return 'N/A';
    }

    get planTaxInfo() {
        if (this.plan?.taxRate) return `(${this.plan?.taxRate.name} ${this.plan?.taxRate.percentage}%)`;
        return '';
    }

    get planTotal() {
        const currency = getCurrencySymbol(this.plan?.currency ? this.plan?.currency : 'USD');
        let amount = this.plan?.price;
        if (this.plan?.taxRate) {
            let taxAmount = (amount / 100) * this.plan?.taxRate.percentage;
            amount += taxAmount;
        }
        return `${currency}${amount.toFixed(2)}`;
    }
}
